import { IEmail } from "models";
import ProfileService from "services/ProfileService";
import { captureExceptionEvent } from "shared-services";

export const sendEmail = async (email: IEmail) => {
  try {
    await ProfileService.shareProfile(email);
  } catch (error) {
    captureExceptionEvent(error);
  }
};
